import React from "react";
import { Modal } from "react-bootstrap";
// import { DEFAULT_INSTANT_RANGE_FROM, DEFAULT_INSTANT_RANGE_TO, listInstantRangeFrom, listInstantRangeTo } from "../common/common"
import { getFilterConfig, updateCar } from "../../model/car";

import { commonErr } from "../common/errors";
import { LoadingInline, LoadingOverlay } from "../common/loading";
import { CarTransmission, CarFuel } from "../common/common";

import { MessageBox } from "../common/messagebox";
import CarMapLocation from "../common/carmaplocation";
// import LocationPicker from "../common/locationpicker"
import FormAddressBox from "../common/formaddress";

import { IcCarSettingGPS } from "../common/svg";

export default class CarSettingInfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",

			isOpenAddressBox: false,
		};
	}

	init = (car) => {
		getFilterConfig().then((resp) => {
			if (resp.data.data) {
				const featuresAll = resp.data.data.allFeatures;
				const features = car.features;
				for (var i = 0; i < featuresAll.length; ++i) {
					for (var j = 0; j < features.length; ++j) {
						if (featuresAll[i].id === features[j].id) {
							featuresAll[i].checked = true;
							break;
						}
					}
				}
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					featuresAll: resp.data.data.allFeatures,
					car: car,
					desc: car.desc,
					fuelConsumption: car.optionsFuelConsumption,
					address: car.locationAddr,
					lat: car.location.lat,
					lng: car.location.lon,
					cityId: car.location.cityId,
					districtId: car.location.districtId,
					wardId: car.location.wardId,
					street: car.location.street,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	onFuelRateChange = (event) => {
		this.setState({
			fuelConsumption: event.target.value,
		});
	};

	onDescChange = (event) => {
		this.setState({
			desc: event.target.value,
		});
	};

	onFeaturesChange = (event) => {
		const featuresAll = this.state.featuresAll.slice();
		for (var i = 0; i < featuresAll.length; ++i) {
			const feature = featuresAll[i];
			if (event.target.value === feature.id) {
				feature.checked = event.target.checked;
			}
		}
		this.setState({
			featuresAll: featuresAll,
		});
	};

	// address
	onAddressLocationUpdate = (location) => {
		this.setState({
			address: location.address,
			lat: location.lat,
			lng: location.lng,
			cityId: location.cityId,
			districtId: location.districtId,
			wardId: location.wardId,
			street: location.street,
		});
	};

	onAddressFocus = (event) => {
		if (!this.state.address || this.state.address === "") {
			this.toggleLocationPicker();
			event.target.blur();
		}
	};

	onAddressChange = (event) => {
		this.setState({
			address: event.target.value,
		});
		if (!event.target.value || event.target.value === "") {
			this.toggleLocationPicker();
			event.target.blur();
		}
	};

	toggleLocationPicker = () => {
		this.setState({
			isShowLocationPicker: !this.state.isShowLocationPicker,
		});
	};

	hideMessageBox = () => {
		this.setState({
			updateErrMsg: "",
		});
	};

	showAddressBox = () => {
		this.setState({
			isOpenAddressBox: true,
		});
	};

	closeAddressBox = () => {
		this.setState({
			isOpenAddressBox: false,
		});
	};

	callingUpdateCarInfo = () => {
		this.updateCarInfo();
	};

	updateCarInfo = () => {
		const { fuelConsumption, desc, featuresAll, address, lat, lng, cityId, wardId, districtId, street } = this.state;

		const features = [];
		for (var i = 0; i < featuresAll.length; ++i) {
			const feature = featuresAll[i];
			if (feature.checked === true) {
				features.push(feature.id);
			}
		}

		this.setState({
			err: commonErr.LOADING,
		});
		updateCar(this.state.car.id, {
			fuelConsumption: fuelConsumption,
			desc: encodeURI(desc),
			features: features,
			address: address,
			lat: lat,
			lon: lng,
			cityId: cityId,
			wardId: wardId,
			districtId: districtId,
			street: street,
		}).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
			});
		});
	};

	render() {
		var content;
		if (this.state.err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else {
			const { car, featuresAll, cityId, wardId, districtId, street, lat, lng, isOpenAddressBox, address } = this.state;

			content = (
				<div className="content">
					{this.state.err === commonErr.LOADING && <LoadingOverlay />}
					{this.state.updateErrMsg && this.state.updateErrMsg !== "" && (
						<MessageBox
							error={this.state.err}
							message={this.state.updateErrMsg}
							show={this.state.updateErrMsg && this.state.updateErrMsg !== ""}
							hideModal={this.hideMessageBox}
						/>
					)}
					<div className="content-container">
						<div className="col-1">
							<h3>Biển số</h3>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input type="text" value={car.licensePlate} disabled={true} />
									</div>
									<span className="note">Thông tin không thể thay đổi.</span>
								</div>
							</div>
						</div>
						<div className="space m clear"></div>

						<div className="form-default">
							<div className="position-relative pos-1">
								<div className="line-form">
									<h3 className="title">Địa chỉ xe</h3>
									{/* <LocationPicker show={this.state.isShowLocationPicker} onHide={this.toggleLocationPicker} onUpdate={this.onAddressLocationUpdate} address={this.state.address} location={{ lat: this.state.lat, lng: this.state.lng }} /> */}
									<FormAddressBox
										show={isOpenAddressBox}
										close={this.closeAddressBox}
										cityId={cityId}
										wardId={wardId}
										districtId={districtId}
										street={street}
										address={address}
										onUpdate={this.onAddressLocationUpdate}
										locAddress={{ lat: this.state.lat, lng: this.state.lng }}
									/>

									<div className="wrap-input has-ico-search">
										<div className="wrap-svg pointer" onClick={this.showAddressBox}>
											<IcCarSettingGPS />
										</div>
										<input
											type="text"
											value={address}
											// onChange={this.onAddressChange}
											// onFocus={this.onAddressFocus}
											disabled={true}
											placeholder={"Địa chỉ mặc định để giao nhận xe."}
											style={{ background: "#fff" }}
										/>
									</div>
								</div>
								{this.state.address !== "" && this.state.lat !== 0 && this.state.lng !== 0 && (
									<CarMapLocation
										address={this.state.address}
										location={{ lat: this.state.lat, lng: this.state.lng }}
									/>
								)}
							</div>
							<div className="space m clear"></div>
							{/* --> */}
						</div>

						<h3>Thông tin cơ bản</h3>
						<div className="form-default">
							<div className="col-1 clear">
								<div className="line-form">
									<label className="label">Số ghế</label>
									<div className="wrap-input">
										<input type="text" value={car.seat} disabled={true} />
									</div>
								</div>
							</div>
							<div className="col-2">
								<div className="line-form">
									<label className="label">Truyền động</label>
									<div className="wrap-input">
										<input type="text" value={CarTransmission[car.optionsTransmission]} disabled={true} />
									</div>
								</div>
							</div>
							<div className="col-1 clear">
								<div className="line-form">
									<label className="label">Loại nhiên liệu</label>
									<div className="wrap-input">
										<input type="text" value={CarFuel[car.optionsFuel]} disabled={true} />
									</div>
								</div>
							</div>
							<div className="col-2">
								<div className="line-form">
									<label className="label">
										Mức tiêu thụ nhiên liệu {car.optionsFuel === 3 ? "(km/lần sạc)" : "(lít/100km)"}
									</label>
									<div className="wrap-input">
										<input type="text" value={this.state.fuelConsumption} onChange={this.onFuelRateChange} />
									</div>
								</div>
							</div>
						</div>
						<div className="space m clear"></div>
						<h3>Mô tả</h3>
						<div className="form-default">
							<div className="line-form end custom-textarea">
								<textarea
									className="textarea"
									wrap="hard"
									onChange={this.onDescChange}
									placeholder="Huyndai Elantra số tự động đăng kí tháng 06/2018.
                            Xe gia đình mới đẹp, nội thất nguyên bản, sạch sẽ, bảo dưỡng thường xuyên, rửa xe miễn phí cho khách.
                            Xe rộng rãi, an toàn, tiện nghi, phù hợp cho gia đình du lịch.
                            Xe trang bị hệ thống cảm biến lùi, gạt mưa tự động, đèn pha tự động, camera hành trình, hệ thống giải trí AV cùng nhiều tiện nghi khác..."
									value={this.state.desc}
								/>
							</div>
						</div>
						<div className="space m clear"></div>
						<h3>Tính năng</h3>
						<div className="car-feature__sect">
							<div className="list-feature">
								{featuresAll &&
									featuresAll.map((option) => {
										return (
											<div className="squaredThree have-label" key={option.id}>
												<input
													id={option.id}
													type="checkbox"
													checked={option.checked ? true : false}
													value={option.id}
													onChange={this.onFeaturesChange}
													name="filter-car-feature"
												/>
												<label className="description" htmlFor={option.id}>
													<div className="thumbnail">
														<img loading="lazy" className="img-fluid" src={option.logo} alt={option.name} />
														<span style={{ fontSize: ".875rem" }}>{option.name}</span>
													</div>
												</label>
											</div>
										);
									})}
							</div>
						</div>
						{/* <div className="list-features">
                        <ul>
                            {featuresAll && featuresAll.map(option => <li key={option.id}>
                                <div className="squaredFour have-label">
                                    <input id={`${option.id}`} type="checkbox" checked={option.checked ? true : false} value={option.id} onChange={this.onFeaturesChange} />
                                    <label htmlFor={`${option.id}`}> <img className="d-flex" style={{ float: "left", width: "16px", height: "16px", marginRight:"5px" }} className="img-ico" src={option.logo} alt="Mioto - Thuê xe tự lái" /> {option.name}</label>
                                </div>
                            </li>)}
                        </ul>
                    </div> */}
						<div className="space m"></div>
						<div className="line"></div>
						<a className="btn btn-primary btn--m" onClick={this.callingUpdateCarInfo}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}

		return content;
	}
}
